import './supBilling.css';
import '../dashboard/dashboardTable/dashboardTable.css';
import { useCallback, useEffect, useState } from 'react';
import Pagination from '../../components/pagination/Pagination';
import ReactLoading from 'react-loading';
import EmptyPage from '../../components/empty-page/emptyPage';
import orgPayoutsData, { fetchMoreDetails, payoutCount } from './supPayoutsFun/fetchOrgPayouts';
import Dialog from '../../components/dialogModal/dialogModal';
import DetailsTable from './detailsTable';
import { standardDate } from '../../utils/formatDate';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { supBillingsServiceConfig } from '../../utils/supportServiceConfig/supBillingsServiceConfig';

const MODE_TO_SERVICE = {
    t: 'trip',
    a: 'act',
    c: 'camp',
    g: 'gu'
};

const SupPayouts = ({ orgData }) => {
    const { orgId, mode } = useParams();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const serviceType = MODE_TO_SERVICE[mode];
    const [loading, setLoading] = useState(false);
    const [payoutData, setPayoutData] = useState([]);
    const tableHeader = ['From Date', 'To Date', 'No. of Bookings', 'Amount', 'Payout Date', 'Action'];
    const urlPage = Number(searchParams.get('page')) || 1;
    const pageNumber = urlPage;
    const limit = 10;
    const offSet = (urlPage - 1) * limit;
    // const [limit, setLimit] = useState(10);
    const [viewDetailsModal, setViewDetailsModal] = useState(false);
    const [moreDetails, setMoreDetails] = useState({});
    const selectedOrg = orgId || '';
    const [totalCount, setTotalCount] = useState(0);
    const totalData = totalCount;
    const totalPages = Math.ceil(totalData / limit);
    const SERVICE_TO_MODE = {
        trip: 't',
        act: 'a',
        camp: 'c',
        gu: 'g'
    };
    const servicePayoutsConfig = supBillingsServiceConfig[serviceType];

    const getPayoutIds = (row) => {
        if (serviceType === 'trip') {
            return row?.tripIds || [];
        }

        if (serviceType === 'gu') {
            return row?.guIds || [];
        }

        if (serviceType === 'act') {
            return row?.actIds || [];
        }

        if (serviceType === 'camp') {
            return row?.campIds || [];
        }

        return [];
    };

    const handleServiceType = (event) => {
        const selectedValue = event.target.value;
        const newMode = SERVICE_TO_MODE[selectedValue];
        navigate(`/support/${newMode}/payouts?${searchParams.toString()}`);
        setPayoutData([]);
    };

    const updateURL = useCallback(
        (params) => {
            const current = Object.fromEntries([...searchParams]);

            Object.keys(params).forEach((key) => {
                if (params[key] === '' || params[key] === null) {
                    delete current[key];
                } else {
                    current[key] = params[key];
                }
            });
            setSearchParams(current);
        },
        [searchParams, setSearchParams]
    );

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            updateURL({ page: number });
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        if (!totalPages) return;

        if (pageNumber > totalPages) {
            updateURL({ page: totalPages });
        }
        //eslint-disable-next-line
    }, [totalPages, pageNumber, updateURL]);

    useEffect(() => {
        if (!orgId) return;
        const fetchPayoutData = async () => {
            await servicePayoutsConfig.fetchPayoutData({
                selectedOrg,
                limit,
                offSet,
                setPayoutData,
                setLoading,
                serviceType
            });
        };

        fetchPayoutData();
    }, [selectedOrg, limit, offSet, serviceType]);

    useEffect(() => {
        if (!orgId) return;
        servicePayoutsConfig.fetchPayoutCount({ selectedOrg, setTotalCount, setLoading, serviceType });
    }, [selectedOrg, serviceType]);

    const handleViewDetails = async (id) => {
        await fetchMoreDetails(id, setMoreDetails, setLoading, serviceType);

        setViewDetailsModal(true);
    };

    return (
        <>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='billingContainer table-top-container'>
                <div className='alignCenter filter'>
                    {/* <input
                        placeholder='Search...'
                        name='orgSearch'
                        value={searchText}
                        className='orgBillSearch'
                        onChange={(sea) => handleTextChange(sea, setSearchText)}
                    /> */}
                    <div className='orgBookingFilters'>
                        <select
                            name='serviceType'
                            id='serviceType'
                            value={serviceType}
                            className='select mr-1'
                            onChange={handleServiceType}
                        >
                            <option value='trip'>Trip</option>
                            <option value='act'>Activity</option>
                            <option value='gu'>Guide</option>
                            <option value='camp'>Camp</option>
                        </select>
                        <select
                            name='org'
                            id='org'
                            className='select'
                            value={selectedOrg}
                            onChange={(e) => {
                                if (e.target.value) {
                                    navigate(`/support/${mode}/payouts/${e.target.value}?page=1`);
                                }
                            }}
                        >
                            <option value=''>Select Organizer</option>
                            {orgData.map((org) => (
                                <option value={org._id} key={org._id}>
                                    {org.companyName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                {payoutData?.length === 0 && !loading ? (
                    <EmptyPage />
                ) : (
                    <div className='tableContainer'>
                        <table className='table'>
                            <thead className='tableHead'>
                                <tr>
                                    {tableHeader.map((head, headIndex) => {
                                        return <th key={headIndex}>{head}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {payoutData?.map((row, rowIndex) => {
                                    return (
                                        <tr key={rowIndex} className='tableBodyRow'>
                                            <td
                                                style={{
                                                    fontWeight: 500,
                                                    fontSize: 12,
                                                    color: '#7d89a4'
                                                }}
                                            >
                                                {row.fromDate ? standardDate(row?.fromDate?.split('T')[0]) : 'N/A'}
                                            </td>
                                            <td>{standardDate(row?.toDate?.split('T')[0]) ?? 'N/A'}</td>
                                            <td>{getPayoutIds(row).length}</td>
                                            <td>₹ {row?.totalAmount ?? '0'}</td>
                                            <td>{standardDate(row?.payoutDate?.split('T')[0]) ?? 'N/A'}</td>
                                            <td>
                                                <button
                                                    className='actBtn payoutBtn noWidth'
                                                    onClick={() => {
                                                        handleViewDetails(row._id);
                                                    }}
                                                >
                                                    View Details
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className='responsiveCardContainer'>
                            {payoutData?.map((row, rowIndex) => (
                                <div key={rowIndex} className='responsiveCard'>
                                    <div className='cardContent'>
                                        <p>
                                            <strong>{tableHeader[0]}:</strong>{' '}
                                            {row.fromDate ? standardDate(row?.fromDate?.split('T')[0]) : 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[1]}:</strong>{' '}
                                            {standardDate(row?.toDate?.split('T')[0]) ?? 'N/A'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[2]}:</strong> {getPayoutIds(row).length}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[3]}:</strong> ₹ {row?.totalAmount ?? '0'}
                                        </p>
                                        <p>
                                            <strong>{tableHeader[4]}:</strong>{' '}
                                            {standardDate(row?.payoutDate?.split('T')[0]) ?? 'N/A'}
                                        </p>
                                        {/* <div className='sendMessageBtn'>
                                            <button
                                                className='actBtn payoutBtn noWidth'
                                                onClick={() => {
                                                    setViewDetailsModal(true);
                                                    handleViewDetails(row._id);
                                                }}
                                            >
                                                View Details
                                            </button>
                                        </div> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <Pagination
                    paginationClick={paginationClick}
                    numberOfRows={totalData}
                    offSet={offSet}
                    pageNumber={pageNumber}
                    limit={limit}
                />
                {viewDetailsModal && (
                    <Dialog openModal={viewDetailsModal} heading={'Details'} className='detailsDialog'>
                        <div className='moreDialogContent'>
                            {moreDetails?.length === 0 && !loading ? (
                                <EmptyPage />
                            ) : (
                                <DetailsTable moreDetails={moreDetails} serviceType={serviceType} />
                            )}
                            <div className='moreDetailsBtn'>
                                <button className='dialogActBtn cancel' onClick={() => setViewDetailsModal(false)}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}
            </div>
        </>
    );
};

export default SupPayouts;
